export default "__VITE_ASSET__BFILb0oX__"